export function clearLocalStorageExcept(keysToKeep: string[]) {
  const saved: { [key: string]: string | null } = {};
  keysToKeep.forEach(key => {
    saved[key] = localStorage.getItem(key);
  });

  localStorage.clear();

  keysToKeep.forEach(key => {
    if (saved[key] !== null) {
      localStorage.setItem(key, saved[key]!);
    }
  });
}

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  return `${day}-${month}-${year} at ${formattedHours}:${minutes} ${ampm}`;
};
